module.exports = __webpack_public_path__ + "img/product-placeholder-30.453929b.png";